<template>
  <span v-if="!loading">{{ userName | displayOptionalValue }}</span>
</template>

<script>

import UserApi from '@/misc/apis/UserApi'
import { isAxiosError } from 'axios'

export default {
  name: 'UserFullnameText',
  props: {
    userId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      user: null,
      isDeleted: false
    }
  },
  computed: {
    userName() {
      if (this.user) {
        return (this.user.profile.firstName ? this.user.profile.firstName + ' ' : '') + this.user.profile.lastName
      } else if (this.isDeleted) {
        return this.$t('message.generic.deleted')
      } else {
        return this.userId
      }
    }
  },
  mounted() {
    UserApi.getUser(this.userId)
      .then(response => {
        this.user = response
      })
      .catch(e => {
        if (isAxiosError(e) && e.status === 404) {
          this.isDeleted = true
        } else {
          console.log(e)
        }
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
